module.exports = require('./lib/validate');
